/**
 * NetworkIndicator — pulsing dot shown when at least one XHR is in
 * flight. Drives user perception of responsiveness; invisible when
 * the app is idle so it doesn't add visual noise.
 *
 * Data source: the `useIsNetworkBusy` hook from `./inflight`, driven
 * by the apiClient interceptors (plan Phase H.3 / H.4).
 */

import { useIsNetworkBusy } from './inflight';
import './NetworkIndicator.css';

type Props = {
    /** Optional label announced to screen readers. Default is
     *  "Loading" which is generic but universally understood. */
    srLabel?: string;
};

export function NetworkIndicator({ srLabel = 'Loading' }: Props) {
    const busy = useIsNetworkBusy();
    if (!busy) return null;
    return (
        <span
            className="network-indicator"
            role="status"
            aria-live="polite"
        >
            <span className="network-indicator__dot" aria-hidden="true" />
            <span className="network-indicator__label">{srLabel}</span>
        </span>
    );
}
